import { useQuery } from 'react-query'

import { HTTPMethod, request } from '../../global/api/legacyApi'
import { getLiveId, getRole } from '../../global/blocs/roomInfo'
import { showNotice } from '../../Layout/Notices/Notices'
import queryClient from '../../queryClient'
import { type APIResponse } from '../../sharedLegacy/utils/api.types'
import { type HandoutDTO, mapDTOToHandout } from '../model/Handout'

const HANDOUTS_QUERY_KEY = ['handouts', 'list']

const invalidateHandouts = () =>
  queryClient.invalidateQueries(HANDOUTS_QUERY_KEY)

const useHandoutsQuery = (liveToken?: string) =>
  useQuery({
    queryKey: HANDOUTS_QUERY_KEY,
    queryFn: async () => {
      const { data } = await request<APIResponse<HandoutDTO[]>>({
        url: '/api/2/live/attachment/list',
        method: HTTPMethod.GET,
        data: {
          live_id: getLiveId(),
          token: liveToken,
        },
      })

      return data.filter((handout) => !handout.hidden_p).map(mapDTOToHandout)
    },
    onError: () => {
      // we do not want to display an error notification if the
      // handouts are failing to load for audience members
      if (getRole() === 'audience') return

      showNotice({
        message: 'Unable to list handouts',
        expirationMillis: 5e3,
        isClosable: true,
      })
    },
  })

export { invalidateHandouts, useHandoutsQuery }
